/// <reference path="../lib/jquery.d.ts" />
import {shim} from './helpers/shim';
import {Controller} from "./helpers/controller";


export class VideoBoxControl extends Controller {


    static REPLACE_ELEMENT_SELECTOR: string = '.video';
    static PADDING_BOTTOM_VIDEO: number = 90;

    static YT: any;

    private timer: number | undefined;

    private player: any;

    private playerReady: boolean = false;

    private pageWrap: JQuery = $('.pageWrap');
    private videoHolder: JQuery | undefined;
    private html: JQuery = $('html');


    constructor(element: HTMLElement) {
        super(element);
        this.initPlayer();
    }

    createVideoHtmlElement(tempScrollTop: number) {

        return ` <div class="videoBox" style="top: ${tempScrollTop}px">
                                        <div class="videoCol contain">
                                            <button class="blueClose">Close</button>
                                            <div class="videoWrap">
                                            <div class="video"></div>
                                            </div>
                                        </div>
                                    </div>`;
    }

    initPlayer() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            if (typeof (shim('YT')) === 'undefined' || typeof (shim('YT').Player) === 'undefined') {
                if (document.querySelectorAll('#youtube-iframe-api').length <= 0) {
                    let tag = document.createElement('script');
                    tag.src = '//www.youtube.com/iframe_api';
                    tag.id = 'youtube-iframe-api';
                    let firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
                }
                this.initPlayer();
            } else {
                VideoBoxControl.YT = shim('YT');
                this.playerReady = true;


                this.$().on('click', () => {

                    let tempScrollTop = $(window).scrollTop();

                    document.body.insertAdjacentHTML('beforeend',this.createVideoHtmlElement(tempScrollTop))
                    this.videoHolder = $('.videoBox');

                    this.loadYoutubeVideo()

                    this.videoHolder.find('.blueClose').on('click', () => {
                        this.pageWrap.removeClass("overlayCover");
                        this.html.css('overflow', "auto");
                        $(window).scrollTop(tempScrollTop);
                        this.videoHolder?.remove();

                        return false;
                    });

                    return false;
                });

            }
        }, 50);
    }

    loadYoutubeVideo() {

        if (this.videoHolder != undefined) {
            let toReplaceElement = this.videoHolder.find(VideoBoxControl.REPLACE_ELEMENT_SELECTOR).get()[0];
            let videoId = this.$().data().youtubeid;
            if (toReplaceElement) {
                this.player = new VideoBoxControl.YT.Player(toReplaceElement, {
                    height: '100%',
                    width: '100%',
                    videoId: videoId,
                    origin: window.origin,
                    events: {
                        'onReady': (event:any) => {
                            this.onPlayerReady(event);
                        }
                    }
                });
                try{
                    this.player.h.attributes.sandbox.value = "allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation";

                } catch {
                    
                }
            } else {
                throw Error('Couldn\'t initialize Video (' + this.$().getAttribute('data-youtube') + '). No Element with the Selector ' + VideoBoxControl.REPLACE_ELEMENT_SELECTOR + ' found.');
            }
        }

    }

    onPlayerReady(event:any) {

        event.target.playVideo();

        this.html.css('overflow', "hidden");
        this.pageWrap.addClass("overlayCover");
        this.videoHolder?.show();
        this.checkVideoSize();
    }
    
    checkVideoSize(){
        let videoHeight = $(".videoBox").innerHeight() - VideoBoxControl.PADDING_BOTTOM_VIDEO;
        let viewportHeight = window.innerHeight;
        let widthControlElement =  $(".videoCol");
        if (viewportHeight < videoHeight){
            widthControlElement.css("max-width","500px");
        }
    }
}
